import { useState, useEffect, useContext } from "react";
import dynamic from "next/dynamic";
import { Store } from "@store";
import axios from "axios";
import { getAllEvents } from "@queries/events.queries";
import styles from "../../src/pujaModule/styles/pujaList.module.css";
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingCircle from "@components/loadings/LoadingCircle";
import { printInConsole } from "@utils/devtools/utils";
import { useTranslation } from "react-i18next";
import PujaItem from "../../src/pujaModule/components/pujaItem";
const NoPostComponent = dynamic(() => import("@components/profile/NoPost"));
export default function CommunityProfilEvents({
  communityID
}) {
  const {
    t
  } = useTranslation();
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [noEvents, setNoEvents] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  useEffect(() => {
    async function getData(token) {
      setIsLoading(true);
      const response = await getAllEvents({
        communityID,
        accessToken: loggedInUser.accessToken,
        cancelToken: token
      }).catch(err => printInConsole(err.message));

      //printInConsole("Events => ", response);

      if (response) {
        if (response.length === 0) {
          setEvents([]);
          setNoEvents(true);
          setHasMore(false);
        } else {
          setEvents(response);
          setHasMore(true);
        }
      } else {
        setNoEvents(true);
        setHasMore(false);
      }
      setIsLoading(false);
    }
    let source = axios.CancelToken.source();
    getData(source.token);
    return () => {
      if (source) source.cancel();
    };
  }, [communityID, loggedInUser]);
  async function updateData() {
    if (!hasMore) {
      return () => {};
    }
    const ts = events[events.length - 1]?.ts;
    const response = await getAllEvents({
      communityID,
      ts: ts,
      accessToken: loggedInUser.accessToken
    }).catch(err => printInConsole(err.message));
    if (response) {
      if (response.length === 0) {
        setHasMore(false);
      } else {
        setEvents(cur => cur.concat(response));
        setHasMore(true);
      }
    } else setHasMore(false);
  }
  if (isLoading) {
    return <LoadingCircle />;
  }
  if (events?.length > 0) {
    return <InfiniteScroll dataLength={events.length} next={updateData} hasMore={hasMore} loader={<LoadingCircle />}>
       <div className={styles.pujasContainer}>
          {events && events.map((data, index) => <PujaItem key={index} index={index} data={data} />)}
        </div>
      </InfiniteScroll>;
  } else if (noEvents) {
    return <NoPostComponent message={t('no-pujas-yet')} />;
  } else return "";
}